import { useMemo } from 'react'
import { ROUTES } from 'constants/routes'
import {
  ArchiveButton,
  AutoReplenishButton,
  DeleteButton,
  RefundButton,
} from 'modules/Services/Network/subcomponents/AccountsList/subcomponents'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const map = ({ l }) => ({
  delete: {
    icon: 'trash',
    component: DeleteButton,
    color: 'Interface-Eighth',
    order: 1,
  },
  archive: {
    icon: 'inbox-archive',
    component: ArchiveButton,
    color: 'Interface-Eighth',
    order: 2,
  },
  access: {
    icon: 'key',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS,
    order: 3,
  },
  access_new: {
    icon: 'key',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS_NEW,
    order: 3,
  },
  refund: {
    icon: 'time-credit',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT_REFUND,
    component: RefundButton,
    order: 4,
    color: 'Interface-Eighth',
  },
  campaigns: {
    icon: 'union',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGNS,
    order: 5,
  },
  'campaign-create': {
    icon: 'plus',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGN_NEW,
    order: 6,
  },
  auto_replenish: {
    icon: 'time-money',
    url: ROUTES.AUTOREPLENISH,
    order: 7,
    component: AutoReplenishButton,
    hideLabel: () => l,
  },
  deposit: {
    icon: 'card',
    url: ROUTES.BILLING_TOP_UP_ACCOUNT,
    variant: 'primary',
    order: 8,
  },
  refresh: {
    icon: 'refresh',
    url: ROUTES.SERVICES_NETWORK_AUTH,
  },
  history: {
    icon: 'transfer',
    url: ROUTES.SERVICES_NETWORK_ACCOUNT,
  },
  deposit_creation_fee: {
    icon: 'card',
    url: ROUTES.BILLING_DEPOSIT_CREATION_FEE,
    variant: 'primary',
  },
})

export { map as actionsMap }

export const useGetAccountAction = (actionName) => {
  const breakpoints = useBreakpoint()

  return useMemo(() => map(breakpoints)[actionName], [actionName])
}
